export function CustomRegistriesPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Custom Registries</h1>
      <p className="text-muted-foreground">Manage custom registry entries.</p>
    </div>
  );
}
